// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__19bLg","col":"styles_col__3_gDE","fulfillmentStatus":"styles_fulfillmentStatus__1xIpS","emailCol":"styles_emailCol__2J99s"};